import { useState, useEffect } from 'react';
import { DataMappingsApi } from '../../clients';

export const useGetAudienceDesignatorOptions = () => {
  const [audienceDesignatorOptions, setAudienceDesignatorOptions] = useState(
    [],
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await DataMappingsApi.getAudienceDesignatorOptions();
        setAudienceDesignatorOptions(response.data.options || []);
      } catch (error) {
        console.error('Failed to fetch audience designator options:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOptions();
  }, []);

  return { audienceDesignatorOptions, loading };
};
